require('../scss/styles.scss')

require('./custom/polyfills')
require('./custom/hooks')
require('./custom/sortenfinder-form')

global.$ = global.jQuery = require('jquery')

require('jquery-ui')
require('./vendor/tether.min.js')
require('./vendor/popper.min')
require('./vendor/bootstrap.min')
require('./vendor/slick.min')
require('./vendor/parsley')
require('./vendor/masonry.min')

require('./1_objects/objects')
require('./2_components/components')

$(document).ready(function () {

  require('../../typo3conf/ext/psr_projects/Resources/Public/js/logic/render')
  require('../../typo3conf/ext/psr_events/Resources/Public/js/logic/render')
  require('../../typo3conf/ext/psr_speciesmap/Resources/Public/js/logic/render')
  require('../../typo3conf/ext/psr_sortenfinder/Resources/Public/js/logic/pins')
  require('../../typo3conf/ext/psr_sortenfinder/Resources/Public/js/logic/renderList')
  require('../../typo3conf/ext/psr_sortenfinder/Resources/Public/js/logic/renderDetail')
  require('../../typo3conf/ext/psr_sortenfinder/Resources/Public/js/logic/renderDirectlinks')
  require('../../typo3conf/ext/psr_sortenfinder/Resources/Public/js/logic/renderMemo')
  require('../../typo3conf/ext/psr_raisenow/Resources/Public/JavaScript/Tamaro/main')
  require('../../typo3conf/ext/psr_raisenow/Resources/Public/JavaScript/Tamaro/config')
  require('../../typo3conf/ext/psr_shop/Resources/Public/JavaScript/shop.js')
  require('../../typo3conf/ext/femanager/Resources/Public/JavaScript/Validation.min.js')
  require('../../typo3conf/ext/femanager/Resources/Public/JavaScript/Femanager.min.js')
  require('../../typo3conf/ext/psr_feusers/Resources/Public/JavaScript')
  require('../../typo3conf/ext/pb_social/Resources/Public/Js/main.js')
  require('./custom/main')
  require('./custom/hometeaser')
  require('./custom/news-infinite')
})
